(function () {
  const root = document.querySelector('[data-hok-welcome-signup]');
  if (!root || root.dataset.customerPresent === 'true') return;
  if (window.Shopify && window.Shopify.designMode) return;

  const core = window.HoKWelcomeSignupCore;
  if (!core) return;

  const closeButtons = root.querySelectorAll('[data-hok-welcome-close]');
  const openButtons = document.querySelectorAll('[data-hok-welcome-open]');
  const autoTrigger = root.dataset.autoTrigger === 'true';
  const dismissKey = 'hokWelcomeSignupDismissedUntil';
  const dismissDays = 7;
  const successDays = 90;
  const testMode = core.isTestMode();
  const forceOpen = new URLSearchParams(window.location.search).get('welcome') === '1';
  const delayMs = testMode ? 900 : 12000;
  const scrollRatio = 0.45;
  const onWelcomePage = window.location.pathname.includes('/pages/get-10-off');
  let opened = false;
  let timer = null;

  function now() {
    return Date.now();
  }

  function daysFromNow(days) {
    return String(now() + days * 24 * 60 * 60 * 1000);
  }

  function storedUntil(key) {
    const value = Number(localStorage.getItem(key) || 0);
    return Number.isFinite(value) ? value : 0;
  }

  function isAutoSuppressed() {
    if (testMode) return false;
    return storedUntil(dismissKey) > now() || core.hasCompletedSignup();
  }

  function syncPillVisibility() {
    openButtons.forEach((button) => {
      button.hidden = core.hasCompletedSignup() || onWelcomePage;
    });
  }

  function openPopup(reason, force) {
    if (core.hasCompletedSignup()) return;
    if (!force && opened) return;
    if (!force && isAutoSuppressed()) return;
    opened = true;
    root.querySelectorAll('[data-hok-welcome-country]').forEach(core.populateCountrySelect);
    root.dataset.triggerReason = reason;
    root.hidden = false;
    document.body.classList.add('hok-welcome-signup-open');
    syncPillVisibility();
  }

  function closePopup(days) {
    root.hidden = true;
    document.body.classList.remove('hok-welcome-signup-open');
    localStorage.setItem(dismissKey, daysFromNow(days || dismissDays));
    syncPillVisibility();
  }

  function onScroll() {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return;
    if (window.scrollY / scrollable >= scrollRatio) {
      window.removeEventListener('scroll', onScroll);
      openPopup('scroll');
    }
  }

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => closePopup(dismissDays));
  });

  openButtons.forEach((button) => {
    button.addEventListener('click', () => openPopup('pill', true));
    button.hidden = false;
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden) closePopup(dismissDays);
  });

  document.addEventListener('hok-welcome-signup:success', () => {
    window.setTimeout(() => closePopup(successDays), 1600);
    syncPillVisibility();
  });

  syncPillVisibility();

  if (forceOpen) {
    openPopup('query', true);
    return;
  }

  if (!autoTrigger || isAutoSuppressed()) return;
  timer = window.setTimeout(() => openPopup('delay'), delayMs);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('pagehide', () => {
    if (timer) window.clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
  });
})();
